import { render, staticRenderFns } from "./procedures-average-card.vue?vue&type=template&id=3bd48060&"
import script from "./procedures-average-card.vue?vue&type=script&lang=js&"
export * from "./procedures-average-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports